
const canvas = document.getElementById("bottle-canvas");

if (canvas) {

  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(
    40,
    1,
    0.1,
    1000
  );

  camera.position.set(0, 0.5, 3.5);

  const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true,
    antialias: true
  });

  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1;

  /* LIGHTS */

  const ambientLight = new THREE.AmbientLight(0xffffff, 1.8);
  scene.add(ambientLight);

  const dirLight = new THREE.DirectionalLight(0xffffff, 1.2);
  dirLight.position.set(5, 10, 7);
  scene.add(dirLight);

  /* MODEL */

  let model;

  const loader = new THREE.GLTFLoader();

  loader.load("https://cdn.shopify.com/3d/models/e53a7fd99bfb1396/MB_bottle3dmodel_vfinal-compressed.glb", function (gltf) {

    model = gltf.scene;

    model.scale.set(5.4, 5.4, 5.4);
    model.rotation.z = -0.3;
    model.rotation.x = 0.15;

    model.position.y = 0.9;
    model.position.x = 0.2;

    scene.add(model);

  });

  /* SIZE CONTROL */

  function updateSize() {

    const container = canvas.parentElement;

    const width = container.offsetWidth;
    const height = container.offsetHeight;

    renderer.setSize(width, height, false);

    camera.aspect = width / height;
    camera.updateProjectionMatrix();
  }

  /* ANIMATION */

  function animate() {

    requestAnimationFrame(animate);

    updateSize();

    if (model) {
      model.rotation.y = Math.sin(Date.now() * 0.002) * 0.3;
    }

    renderer.render(scene, camera);

  }

  animate();

  window.addEventListener("resize", updateSize);

}


const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.nav-links');

  toggle.addEventListener('click', () => {
    nav.classList.toggle('active');
  });


document.addEventListener("DOMContentLoaded", function () {

  const track = document.querySelector('.slider-tracks');
  const slides = document.querySelectorAll('.slides');
  const next = document.querySelector('.next');
  const prev = document.querySelector('.prev');
  const dotsContainer = document.querySelector('.dots');

  let index = 0;

  /* ===== Create Dots ===== */
  slides.forEach((_, i) => {
    const dot = document.createElement('span');
    if (i === 0) dot.classList.add('active');
    dotsContainer.appendChild(dot);
  });

  const dots = document.querySelectorAll('.dots span');

  function updateSlider() {
    track.style.transform = `translateX(-${index * 50}%)`;

    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  }

  /* ===== Next ===== */
  next.addEventListener('click', () => {
    index++;
    if (index >= slides.length - 1) index = 0;
    updateSlider();
  });

  /* ===== Prev ===== */
  prev.addEventListener('click', () => {
    index--;
    if (index < 0) index = slides.length - 2;
    updateSlider();
  });
let startX = 0;
let endX = 0;

track.addEventListener("touchstart", (e) => {
  startX = e.touches[0].clientX;
});

track.addEventListener("touchmove", (e) => {
  endX = e.touches[0].clientX;
});

track.addEventListener("touchend", () => {
  let diff = startX - endX;

  if (Math.abs(diff) > 50) { // minimum swipe distance
    if (diff > 0) {
      // swipe left → next
      index++;
      if (index >= slides.length - 1) index = 0;
    } else {
      // swipe right → prev
      index--;
      if (index < 0) index = slides.length - 2;
    }
    updateSlider();
  }
});
});






document.addEventListener("DOMContentLoaded", function () {

  const menuToggle = document.querySelector(".menu-toggle");
  const mobileMenu = document.getElementById("mobileMenu");

  if (!menuToggle || !mobileMenu) return;

  menuToggle.addEventListener("click", function () {

    setTimeout(function () {

      if (mobileMenu.classList.contains("active")) {
        document.body.classList.add("menu-open");
      } else {
        document.body.classList.remove("menu-open");
      }

    }, 50);

  });

});